import { invoiceService } from '../../services'
import Vue from 'vue'
import saveAs from 'file-saver'

export class InvoiceBase {
  constructor () {
    this.state = {
      all: {
        filterInitialized: false,
        loading: true,
        items: {},
        currentPage: 1,
        filter: {},
        meta: {}
      }
    }
  }

  actions () {
    const that = this
    return {
      initialize ({ commit }) {
        commit('initialize')
      },

      resetFilter ({ commit }) {
        commit('resetFilter')
      },

      recreateInvoicePdf ({ commit }, invoiceId) {
        return invoiceService.recreateInvoicePdf(invoiceId)
          .then(data => {
            return data.result
          })
          .catch(error => {
            return error
          })
      },

      getListData ({ commit }) {
        commit('getListDataRequest')
        return invoiceService.getListData(that.state.all.filter, that.state.all.currentPage)
          .then(data => {
            commit('getListDataSuccess', data.result)
            return data.result
          })
      },

      getInvoiceableProjects ({ commit }, page) {
        commit('getListDataRequest')
        return invoiceService.getInvoiceableProjects(that.state.all.filter, page)
          .then(data => {
            commit('getListDataSuccess', data.result)
            return data.result
          })
      },

      createPreviewFromProjectId ({ commit }, projectId) {
        return invoiceService.createPreviewFromProjectId(projectId)
          .then(data => {
            commit('createPreviewSuccess')
            return data.result
          })
          .catch(error => {
            commit('createPreviewFailure')
            return error
          })
      },

      createPreviewPdfFromProjectId ({ commit }, projectId) {
        return invoiceService.createPreviewPdfFromProjectId(projectId)
          .then(data => {
            return data.result
          })
          .catch(error => {
            return error
          })
      },

      createCreditInvoicePreview ({ commit }, invoiceId) {
        return invoiceService.createCreditInvoicePreview(invoiceId)
          .then(data => {
            commit('createPreviewSuccess')
            return data.result
          })
          .catch(error => {
            commit('createPreviewFailure')
            return error
          })
      },

      createFromProjectId ({ commit, dispatch }, projectId) {
        return invoiceService.createFromProjectId(projectId)
          .then(data => {
            dispatch('projects/getListData', 1, { root: true })
            commit('createFromProjectIdSuccess', data.result.invoiceCode)
            return data.result
          })
          .catch(error => {
            commit('createFailure')
            return error
          })
      },

      createCreditInvoice ({ commit, dispatch }, invoiceId) {
        return invoiceService.createCreditInvoice(invoiceId)
          .then(data => {
            dispatch('getListData', 1)
            commit('createCreditInvoiceSuccess', data.result.serialNumberPadded)
            return data.result
          })
          .catch(error => {
            commit('createCreditInvoiceFailure')
            return error
          })
      },

      downloadInvoicePdf ({ commit }, invoice) {
        invoiceService.downloadInvoicePdf(invoice.invoiceId)
          .then(response => {
            var blob = new Blob([response.data], {type: 'application/pdf'})
            saveAs(blob, invoice.invoiceCode + '.pdf')
          }).catch(error => {
            console.error(error)
          })
      }
    }
  }

  getters () {
    return {
      isFilterChanged: state => (route) => {
        // Page should not be considered when comparing
        const currentFilter = Object.assign({}, state.all.filter)
        const defaultFilter = Object.assign({}, state.all.defaultFilter)

        currentFilter.page = null
        defaultFilter.page = null

        return !Vue.lodash.isEqual(currentFilter, defaultFilter)
      }
    }
  }

  mutations () {
    const ret = {
      resetFilter (state) {
        state.all.currentPage = 1
        state.all.filter = Object.assign({}, state.all.defaultFilter)
      },

      initialize (state) {
        if (!state.all.filterInitialized) {
          ret.resetFilter(state)
          state.all.filterInitialized = true
        }
      },

      getListDataRequest (state) {
        state.all.loading = true
      },

      getListDataSuccess (state, data) {
        state.all.items = data.items
        state.all.meta = data.meta
        state.all.loading = false
      },

      // Preview
      createPreviewSuccess (state, data) {
        Vue.prototype.$toast('Förhandsgranskning skapad', 'success')
      },
      createPreviewFailure (state, error) {
        Vue.prototype.$toast('Kunde inte skapa förhandsgranskning', 'error')
      },

      // Create
      createFromProjectIdSuccess (state, invoiceCode) {
        Vue.prototype.$toast('Faktura ' + invoiceCode + ' skapad', 'success')
      },
      createFailure (state, error) {
        Vue.prototype.$toast('Kunde inte skapa faktura', 'error')
      },

      // Credit invoice
      createCreditInvoiceSuccess (state, serialNumberPadded) {
        Vue.prototype.$toast('Kreditfaktura ' + serialNumberPadded + ' skapad', 'success')
      },
      createCreditInvoiceFailure (state, error) {
        Vue.prototype.$toast('Kunde inte skapa kreditfaktura', 'error')
      }
    }

    return ret
  }
}



// WEBPACK FOOTER //
// ./src/store/base-classes/invoice-base.js